import { createFileRoute } from '@tanstack/react-router';
import { EventDetailPage } from '@pages/events';

/** Veranstaltungsdetail-Route (/events/:eventId) */
export const Route = createFileRoute('/_authenticated/events/$eventId')({
  component: EventDetailPage,
});
